import { render, staticRenderFns } from "./keepCustomerDetail.vue?vue&type=template&id=23a6f1f9&scoped=true&"
import script from "./keepCustomerDetail.vue?vue&type=script&lang=js&"
export * from "./keepCustomerDetail.vue?vue&type=script&lang=js&"
import style0 from "./keepCustomerDetail.vue?vue&type=style&index=0&id=23a6f1f9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23a6f1f9",
  null
  
)

export default component.exports